import { useCallback } from "react";

import { IconButton, useClipboard } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { Icon } from "@shared/ui/chakra/data-display/icon";
import { useToaster } from "@shared/ui/chakra/feedback/toast";

type Props = {
  name: string;
  size?: string;
  value: string;
};

export const CopyButton = ({ name, size, value }: Props) => {
  const { copied, copy } = useClipboard({ value });
  const { formatMessage } = useIntl();
  const toaster = useToaster();

  const handleClick = useCallback(() => {
    copy();
    toaster.success({
      description: formatMessage(
        { id: "copy.alert", defaultMessage: "Значение {name} скопированно!" },
        { name },
      ),
    });
  }, [copy, formatMessage, name, toaster]);

  return (
    <IconButton
      height={size}
      variant="plain"
      width={size}
      onClick={handleClick}
    >
      <Icon color="text.fg_subtle" name={copied ? "Check" : "Copy"} />
    </IconButton>
  );
};
